import { render, staticRenderFns } from "./BlogPage.vue?vue&type=template&id=98be02d4&scoped=true"
import script from "./BlogPage.vue?vue&type=script&lang=js"
export * from "./BlogPage.vue?vue&type=script&lang=js"
import style0 from "./BlogPage.vue?vue&type=style&index=0&id=98be02d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98be02d4",
  null
  
)

export default component.exports